import React, { useState, useEffect } from 'react';
import  { Container, Row, Col, Button, Form, Breadcrumb } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../page-layout/header/Header';
import NavMenu from '../navigation/Navmenu';
import Footer from '../page-layout/footer/Footer';
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import moment from 'moment';
import { GetUser, DeleteUser } from '../../utils/axios/UserApi';
import { ConfirmAlert, TimerAlert } from '../../utils/swtAlert';
import { GrokLoading } from "../page-layout/loading/Loading";
import { Decrypt } from '../../utils/Helper';
import { GetOrganization } from '../../utils/axios/CompanyAPI';
import { GetLookUps } from '../../utils/axios/LookUpAPI';
import { ORGANIZATION_TYPE, IS_GROVATOR } from "../constants/constants";

const User = () => {
    const navigate = useNavigate();
    const [userInfo, setuserInfo] = useState(JSON.parse(Decrypt(sessionStorage.getItem('userInfo'))));
    const [data, setData] = useState();
    const [edit, setEdit] = useState(false);
    const [view, setView] = useState(false);
    const [loading, setLoading] = useState(true);
    const [organizationTypeId, setOrganizationTypeId] = useState('');
    const [organizationTypeList, setOrganizationTypeList] = useState([]);
    const [organizationList, setOrganizationList] = useState([]);
    const [getAndBind, setGetAndBind] = useState('');
    const [organizationId, setOrganizationId] = useState('');
    const [hidden,setHidden] = useState(true);
    const [isGrovator,setisGrovator] = useState('');
    const [grovatorcollegetype,setgrovatorcollegetype] = useState([]);
    const [groktype,setGroktype] = useState();

    const columns = [
        {
          name: "Name",
          width: "250px",
          selector:  row => row.Name,
          sortable:true,
          cell: row => row.Name,
        },
        {
          name: "Email",
          width: "300px",
          selector: row => row.Email,
          sortable: true,
          cell: row => row.Email,
        },
        {
          name: "Role Name",
          width: "200px",
          selector: row => row.RoleId?.Name,
          sortable: true,
          cell: row => row.RoleId?.Name,
        },
        {
          name: "Contact Number",
          width: "230px",
          selector: row => row.ContactNumber,
          sortable: true,
          cell: row => row.ContactNumber,
        },
        {
            name: "Actions",
            width: "240px",
            cell: (row) => (<>
                <button className="btn btn-link ms-1" title="Edit" onClick={() => handleUserEdit(row._id)} ><span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><path d="M19.045 7.401c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586c-.378-.378-.88-.586-1.414-.586s-1.036.208-1.413.585L4 13.585V18h4.413L19.045 7.401zm-3-3 1.587 1.585-1.59 1.584-1.586-1.585 1.589-1.584zM6 16v-1.585l7.04-7.018 1.586 1.586L7.587 16H6zm-2 4h16v2H4z"></path></svg></span></button>
                <button className="btn btn-link ms-1" title="Delete" onClick={() => handleButtonDelete(row._id)}><span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z"></path></svg></span></button>
            </>),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
      ];
      
    const tableData = {
      columns,
      data,
    };

    const addUser = () => {
        navigate('/userdetails',  {state: {userid: null} });
    }

    const handleUserEdit = (id) => {
        navigate('/userdetails',  {state: {userid: id} });
    }

    const BackBtn = () => {
        navigate('/home');
    }

    const handleButtonDelete = async (id) => {
        ConfirmAlert("Do you want to delete this User!", 'Are you sure?', 'warning', 'Yes, delete this User!').then(
            async (result) => {
                if (result.isConfirmed) {
                    var response = await DeleteUser(id);
                    if (response) {
                        TimerAlert("success", "User Deleted Successfully", "success");
                        getRemainingUsers();
                    }
                }
            }
        )
    }

    const handleorgtypechange = (e) =>{
        setisGrovator(e);
        if(e === IS_GROVATOR.ASSOCIATED){
            setGroktype(true);
            orgTypeChanged(organizationTypeId,true);
        }
        else if(e === IS_GROVATOR.NON_ASSOCIATED){
            setGroktype(false);
            orgTypeChanged(organizationTypeId,false);
        }
        else{
            setData('');
            
        }
    }

    const getUser = async (orgId) => {
        let userPayload = {
            OrganizationId: orgId
        }
        var userResponse = await GetUser(userPayload);
        setData(userResponse.data)
        setLoading(false);
    }

    const getRemainingUsers = async () => {
        let userPayload = {
            OrganizationId: getAndBind
        }
        var userResponse = await GetUser(userPayload);
        setData(userResponse.data)
        setLoading(false);
    }

    const bindFormPreloadData = async () => {
        setLoading(true);
        let grovatorcollegepayload ={
            Type:9
        }
        var grovatorcollegeResponse = await GetLookUps(grovatorcollegepayload);
        console.log(grovatorcollegeResponse);
        setgrovatorcollegetype(grovatorcollegeResponse.data);
        setLoading(false);

    };

    const getOrganizationType = async () => {
        let orgTypePayload = {
            Type: 5
        }
        var orgType = await GetLookUps(orgTypePayload);
        setOrganizationTypeList(orgType.data);
        setLoading(false);
    }

    const handlechangecollegetype =(event) => {
        setisGrovator('');
        setOrganizationTypeId(event.target.value);
        if(event == ''){
            setHidden(true);
        }
        else  if(event.target.value ==ORGANIZATION_TYPE.COLLEGE){
            setOrganizationList([]);
             setHidden(false);
        }
        else{
            orgTypeChanged(event.target.value);
            setHidden(true);
        }
    }

    const orgTypeChanged = async (orgid, groktypes) => {
        if (orgid) {
            if(orgid == ORGANIZATION_TYPE.COLLEGE){
                let organizationPayload = {
                    OrganizationType: orgid,
                    isGrovator: groktypes
                }
                setLoading(true);
                var orgResponse = await GetOrganization(organizationPayload);
                setOrganizationList(orgResponse.data);
            }
            else{
                let organizationPayload = {
                    OrganizationType: orgid,
                }
                setLoading(true);
                var orgResponse = await GetOrganization(organizationPayload);
                setOrganizationList(orgResponse.data);
            }
            
            setData([]);
            setOrganizationId('');
            setLoading(false);
            
        }
        else{
            setOrganizationList([]);
            setData([]);
        }
    };

    const orgNameChanged = (e) => {
            setLoading(false);
            setOrganizationId(e.target.value);
            const OrgId = e.target.value
            setGetAndBind(OrgId)
            getUser(e.target.value);
            setLoading(true);
    }

    const addRefresh = () => {
        navigate('/home', {state: {userid: null}});
    }
    useEffect(() => {
        getOrganizationType();
        bindFormPreloadData();
        setTimeout(() => {
            document.getElementById('nav-dropdownSuperadmin').parentElement.classList.add('show');
            document.getElementById('nav-dropdownSuperadmin').nextSibling.classList.add('show');
        }, 300);
    }, [])


    return (
        <div className='page'>
        {loading ? <GrokLoading /> : ""}
            <NavMenu />
            <Header />
            <div className='page-wrapper'>
                <Container fluid>
                    {/* Start Page Header */}
                    <div className='page-header d-print-none'>
                        <Row className='g-2 align-items-center pb-1'>
                            <div>
                                <Breadcrumb className="custom-breadcrumb">
                                    <Breadcrumb.Item onClick={() => addRefresh()}>Home</Breadcrumb.Item>
                                    <Breadcrumb.Item active> Users</Breadcrumb.Item>
                                </Breadcrumb>
                            </div>
                            <Col style={{ display: 'flex', alignItems: 'center' }}>
                                <Button className='nave-icon' variant='outline' size='sm'title='User'>
                                <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M16.67 13.13C18.04 14.06 19 15.32 19 17v3h4v-3c0-2.18-3.57-3.47-6.33-3.87zM15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4c-.47 0-.91.1-1.33.24a5.98 5.98 0 010 7.52c.42.14.86.24 1.33.24zM9 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM9 13c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4zm6 5H3v-.99C3.2 16.29 6.3 15 9 15s5.8 1.29 6 2v1z"></path></svg></span>
                                </Button>
                                <h2 className="page-title"> Users</h2>
                            </Col>
                            <Col className="mb-1 me-3 col-md-auto">
                                <button className='newBtn_style' onClick={() => BackBtn()}>
                                    <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M249.38 336L170 256l79.38-80m-68.35 80H342"></path><path fill="none" strokeMiterlimit="10" strokeWidth="32" d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"></path></svg></span>
                                    &nbsp;&nbsp;Back
                                </button>
                            </Col>
                        </Row>
                    </div>
                    {/* End Page Header */}
                    <div className='py-3'>
                        <div className='card mb-3 mb-lg-5 '>
                            {/* Header */}
                            <div className='card-header'>
                                <Row className="row justify-content-between align-items-center flex-grow-1">
                                    <Col className='col-md mb-2 md-mb-0'>
                                        <div className="d-flex justify-content-between align-items-center">
                                            {/* <div className="card-title fw-bold mb-0">Users list</div> */}
                                        </div>
                                    </Col>
                                    {/* End Col */}
                                    <Col className='col-12 col-md-auto ms-auto d-print-none'>
                                        {/* <div className="form-group position-relative">
                                            <form className="d-flex mb-2 mb-md-0">
                                                <div className="form-group position-relative">
                                                    <input className="form-control leftpadding" id="text" variant="outlined" placeholder='Users Name' onChange={handleName} />
                                                </div>
                                            </form>
                                        </div> */}
                                    </Col>
                                    <Col lg={2} className='col-12 col-md-auto ms-auto d-print-none mb-3 mb-lg-0'>
                                        <Form.Group>
                                            <div className="col">
                                                <Form.Select as="select" required value={organizationTypeId} onChange={handlechangecollegetype} >
                                                    <option value={''}>Organization Type</option>
                                                    {organizationTypeList.map(item => (
                                                        <option key={item._id} value={item._id}>{item.Name}</option>
                                                    ))}
                                                </Form.Select>
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={2} hidden={hidden}>
                                        <Form.Select as="select" value={isGrovator}  onChange={(e) => handleorgtypechange(e.target.value)}>
                                            <option value={""}> College Type</option>
                                            {grovatorcollegetype.map((item) => 
                                            <option value={item._id} key={item._id}>{item.Name}</option>
                                            )}
                                        </Form.Select>
                                    </Col>                                   
                                    <Col lg={3} className='col-12 col-md-auto ms-auto d-print-none mb-3 mb-lg-0'>
                                        <Form.Group>
                                            <div className="col">
                                                <Form.Select as="select" required value={organizationId} onChange={orgNameChanged} >
                                                    <option value={''}>Organization Name</option>
                                                    {organizationList.map(item => (
                                                        <option key={item._id} value={item._id}>{item.Name}</option>
                                                    ))}
                                                </Form.Select>
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col className='col-12 col-md-auto ms-auto d-print-none'>
                                        <button className="backBtn_style" onClick={() => addUser()} >
                                            Add User
                                        </button>
                                    </Col>
                                </Row>
                                {/* End Row */}
                            </div>
                            <div className='taablist mb-3'>
                              <DataTableExtensions {...tableData}>
                                  <DataTable
                                      columns={columns}
                                      data={data}
                                      fixedHeader
                                      defaultSortField="id"
                                      defaultSortAsc={false}
                                      pagination
                                      paginationPerPage={20}
                                      noDataComponent="Please select organization type & name"
                                      paginationRowsPerPageOptions={[20, 30, 50, 100]}
                                  />
                              </DataTableExtensions>
                            </div>
                        </div>
                    </div>
                </Container>
                <Footer />
            </div>
        </div>
    )
}

export default User; 